export default "__VITE_ASSET__53371ef4__"